import {
  boolean,
  index,
  integer,
  pgTable,
  text,
  timestamp,
  varchar,
} from 'drizzle-orm/pg-core';
import { id, timestamps } from './_shared';

/**
 * Discovery Gmail accounts the platform uses as a job-search assistant
 * identity. Distinct from the user's primary Google account (the one used
 * for sign-in + Gmail Drafts outreach). This account is what registers on
 * Seek / Glassdoor / Indeed, receives alert emails, and (Phase B) is the
 * login the headless-browser bot uses for daily searches.
 *
 * Refresh tokens are stored encrypted in SecretsService — only the secret
 * id is persisted here.
 */
export const discoveryAccounts = pgTable(
  'discovery_accounts',
  {
    id: id(),
    userId: text('user_id').notNull(), // platform user who owns this discovery identity
    email: text('email').notNull(),
    googleSub: text('google_sub').notNull(),
    displayName: varchar('display_name', { length: 200 }),
    picture: text('picture'),
    refreshTokenSecretId: text('refresh_token_secret_id').notNull(),
    enabled: boolean('enabled').default(true).notNull(),
    lastPolledAt: timestamp('last_polled_at', { withTimezone: true }),
    lastJobsFound: integer('last_jobs_found'),
    lastError: text('last_error'),
    ...timestamps,
  },
  (t) => ({
    userIdx: index('discovery_accounts_user_idx').on(t.userId),
    emailIdx: index('discovery_accounts_email_idx').on(t.email),
  }),
);
